export enum CourseStatusEnum {
  published = "published",
  draft = "draft",
  inReview = "in-review",
}
